export default __webpack_public_path__ + "static/media/Sisto.5fa13e0c.png";